import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgSimple(props) {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_jsx("mask", Object.assign({
      id: "simple_svg__a",
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 64,
      height: 64
    }, {
      children: _jsx("path", {
        fill: "#fff",
        d: "M0 0h64v64H0z"
      }, void 0)
    }), void 0), _jsxs("g", Object.assign({
      mask: "url(#simple_svg__a)",
      strokeWidth: 3
    }, {
      children: [_jsx("ellipse", {
        cx: 16.802,
        cy: 47.187,
        rx: 12.802,
        ry: 12.813,
        stroke: "#FF6652"
      }, void 0), _jsx("path", {
        d: "M18.13 27.244L31.16 5.368a.949.949 0 011.63 0l13.029 21.876a.949.949 0 01-.815 1.434H18.945a.949.949 0 01-.815-1.434z",
        stroke: "#7373FF"
      }, void 0), _jsx("rect", {
        x: 36.293,
        y: 35.322,
        width: 23.707,
        height: 23.729,
        rx: 2.846,
        stroke: "#7373FF"
      }, void 0)]
    }), void 0)]
  }), void 0);
}

export default SvgSimple;